import { useState, type FormEvent } from "react";
import { Button } from "@/ui/button";
import { Input } from "@/ui/input";
import { Label } from "@/ui/label";
import { DEADLINE_DAYS_MAX, DEADLINE_DAYS_MIN } from "../settingsApi";

type Props = {
  value: number;
  onSave: (days: number) => void | Promise<void>;
  saving?: boolean;
};

/** Ô số ngày trả ảnh sửa (câu 7a). Từ chối số ngoài khoảng NGAY trên màn:
 *  máy chủ cũng kẹp, nhưng kẹp lặng lẽ là người gõ 9 tưởng đã lưu 9.
 *
 *  `noValidate` để câu báo là câu tiếng Việt của mình, không phải bong bóng
 *  mặc định của trình duyệt — mỗi trình duyệt nói một kiểu. */
export function DeadlineSetting({ value, onSave, saving = false }: Props) {
  const [draft, setDraft] = useState(String(value));
  const [error, setError] = useState<string | null>(null);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const text = draft.trim();
    const days = Number(text);
    if (text === "" || !Number.isInteger(days) || days < DEADLINE_DAYS_MIN || days > DEADLINE_DAYS_MAX) {
      setError(`Chỉ nhận từ ${DEADLINE_DAYS_MIN} tới ${DEADLINE_DAYS_MAX} ngày.`);
      return;
    }
    setError(null);
    void onSave(days);
  };

  return (
    <form noValidate onSubmit={submit} className="space-y-2">
      <Label htmlFor="cskh-deadline-days">Số ngày trả ảnh</Label>
      <div className="flex items-center gap-2">
        <Input
          id="cskh-deadline-days"
          type="number"
          inputMode="numeric"
          min={DEADLINE_DAYS_MIN}
          max={DEADLINE_DAYS_MAX}
          step={1}
          value={draft}
          disabled={saving}
          aria-invalid={error !== null}
          aria-describedby="cskh-deadline-hint"
          onChange={(e) => {
            setDraft(e.target.value);
            setError(null);
          }}
          className="w-24"
        />
        <Button type="submit" disabled={saving}>
          {saving ? "Đang lưu…" : "Lưu"}
        </Button>
      </div>
      {error && (
        <p role="alert" className="text-xs text-destructive">
          {error}
        </p>
      )}
      <p id="cskh-deadline-hint" className="text-xs text-muted-foreground">
        Tính từ lúc khách bấm chốt ảnh. Đổi ở đây chỉ áp cho đơn chốt sau khi lưu — đơn đang
        chạy giữ nguyên hạn đã hứa với khách.
      </p>
    </form>
  );
}
